// Lightweight i18n for Xpertpests — English / Spanish.
// Usage: const { t, lang, setLang } = useLang();  t('book.title')
import React, { createContext, useContext, useState, useCallback } from 'react';

const STR = {
  en: {
    'common.backHome': 'Back to home',
    'book.badge': 'REQUEST SERVICE',
    'book.title': 'Book your pest service',
    'book.subtitle': 'Tell us what you need and we will reach out to schedule. Prefer to talk? Call',
    'book.successTitle': 'Request received!',
    'book.successMsg': 'Thanks {name} — our team will contact you shortly to confirm your appointment.',
    'book.name': 'Full name *',
    'book.namePh': 'Jane Doe',
    'book.phone': 'Mobile phone *',
    'book.phonePh': '(562) 555-1234',
    'book.email': 'Email',
    'book.emailPh': 'you@email.com',
    'book.date': 'Preferred date',
    'book.address': 'Service address',
    'book.addressPh': '123 Main St, City, CA',
    'book.need': 'What do you need?',
    'book.selectService': 'Select a service…',
    'book.notes': 'Notes',
    'book.notesPh': 'Anything we should know?',
    'book.consentMain': 'I agree to receive recurring automated service text messages (e.g., appointment reminders, on-the-way alerts, and payment reminders) from {company} at the phone number provided. Consent is not a condition of purchase. Message frequency varies. Message & data rates may apply. Reply STOP to cancel or HELP for help. See our',
    'book.consentAnd': '&',
    'book.smsTerms': 'SMS Terms',
    'book.privacy': 'Privacy Policy',
    'book.errNamePhone': 'Please enter your name and phone number.',
    'book.errGeneric': 'Something went wrong. Please call us instead.',
    'book.submit': 'Request my appointment',
    'book.sending': 'Sending…',
    'book.disclaimer': 'By submitting you agree to be contacted about your service request.',
    'svc.General Pest Control': 'General Pest Control',
    'svc.Termite Inspection / Treatment': 'Termite Inspection / Treatment',
    'svc.Rodent Control': 'Rodent Control',
    'svc.Bed Bugs': 'Bed Bugs',
    'svc.Ants / Roaches': 'Ants / Roaches',
    'svc.Bee / Wasp Removal': 'Bee / Wasp Removal',
    'svc.Commercial Service': 'Commercial Service',
    'svc.Other': 'Other',
    'pay.loading': 'Loading your invoice…',
    'pay.invalidTitle': 'Link not available',
    'pay.questions': 'Questions? Call {phone} or email {email}.',
    'pay.invoice': 'Invoice',
    'pay.billTo': 'Bill to',
    'pay.due': 'Due',
    'pay.paidTitle': 'This invoice is already paid',
    'pay.paidMsg': 'Thank you! No payment is due.',
    'pay.service': 'Service',
    'pay.amountDue': 'Amount due',
    'pay.redirecting': 'Redirecting to secure checkout…',
    'pay.payNow': 'Pay {amount} now',
    'pay.stripeOff': 'Online card payment is not enabled yet. Please call {phone} to pay.',
    'pay.secure': 'Secure payment powered by Stripe',
    'pay.errInvalid': 'This payment link is invalid or has expired.',
    'pay.errStart': 'Could not start the payment. Please try again.',
    'login.title': 'Sign in to your account',
    'login.subtitleDemo': 'Choose your role and use the demo credentials.',
    'login.subtitle': 'Enter your credentials to continue.',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.forgot': 'Forgot?',
    'login.remember': 'Keep me signed in',
    'login.signInAs': 'Sign In as {role}',
    'login.signingIn': 'Signing in…',
    'login.enterBoth': 'Enter email and password',
    'login.invalid': 'Invalid email or password',
    'login.failed': 'Login failed. Please try again.',
    'login.welcome': 'Welcome, {name}!',
    'login.newTo': 'New to Xpertpests?',
    'login.bookDemo': 'Book a demo',
    'role.admin': 'Admin',
    'role.tech': 'Technician',
    'role.customer': 'Customer',
    'portal.nav.overview': 'Overview',
    'portal.nav.book': 'Book Service',
    'portal.nav.messages': 'Messages',
    'portal.nav.invoices': 'Invoices',
    'portal.nav.history': 'Service History',
    'portal.nav.documents': 'Documents',
    'portal.nav.profile': 'My Account',
    'portal.upcoming': 'Upcoming Visits',
    'portal.reschedule': 'Request a different date',
    'portal.pay.title': 'Payment History',
    'portal.pay.none': 'No payments on file yet.',
    'portal.docs.title': 'Documents & Agreements',
    'portal.docs.none': 'No documents have been sent to you yet.',
    'portal.docs.sign': 'Review & sign',
    'portal.profile.title': 'My Account',
    'portal.profile.email': 'Email for notices',
    'portal.profile.save': 'Save',
    'portal.profile.saved': 'Contact details updated.',
    'portal.profile.error': 'Could not load your account.',
    'portal.profile.addressNote': 'To change the service address, send us a message.',
    'portal.title': 'Customer Portal',
    'portal.customer': 'Customer',
    'portal.signOut': 'Sign Out',
    'portal.welcomeBack': 'Welcome back,',
    'portal.nextService': 'Next scheduled service:',
    'portal.noUpcoming': 'No upcoming visit is scheduled yet.',
    'portal.book.phone': 'Best phone number',
    'portal.book.sending': 'Sending…',
    'portal.book.error': 'Could not send your request. Please call or message us.',
    'portal.hist.none': 'No completed visits on file yet.',
    'portal.hist.loading': 'Loading…',
    'portal.accountNo': 'Account #',
    'portal.plan': 'Plan',
    'portal.planQuarterly': 'Quarterly',
    'portal.openBalance': 'Open Balance',
    'portal.recentInvoices': 'Recent Invoices',
    'portal.viewAll': 'View All Invoices',
    'portal.quickActions': 'Quick Actions',
    'portal.scheduleNew': 'Schedule New Service',
    'portal.scheduleNewSub': 'Book one-time or recurring',
    'portal.updatePay': 'Update Payment Method',
    'portal.updatePaySub': 'Card on file, autopay',
    'portal.viewHistory': 'View Service History',
    'portal.viewHistorySub': 'Reports & receipts',
    'portal.yourTech': 'Your Technician',
    'portal.leadTech': 'Assigned technician',
    'portal.call': 'Call',
    'portal.book.title': 'Book a Service',
    'portal.book.subtitle': 'Send a request and our office will contact you to confirm a time.',
    'portal.book.serviceType': 'Service Type',
    'portal.book.date': 'Preferred Date',
    'portal.book.time': 'Preferred Time',
    'portal.book.address': 'Service Address',
    'portal.book.notes': 'Notes for the Technician',
    'portal.book.notesPh': 'Pet at home, gate code, problem areas…',
    'portal.book.confirm': 'Send Request',
    'portal.book.success': 'Request sent. Our office will contact you to confirm the appointment.',
    'portal.svc.quarterly': 'Quarterly Pest Treatment',
    'portal.svc.termite': 'Termite Inspection',
    'portal.svc.bedbug': 'Bed Bug Treatment',
    'portal.svc.mosquito': 'Mosquito Treatment',
    'portal.svc.rodent': 'Rodent Service',
    'portal.inv.title': 'Your Invoices',
    'portal.inv.colInvoice': 'Invoice',
    'portal.inv.colDate': 'Date',
    'portal.inv.colStatus': 'Status',
    'portal.inv.colAmount': 'Amount',
    'portal.inv.loading': 'Loading…',
    'portal.inv.none': 'No invoices yet.',
    'portal.inv.view': 'View',
    'portal.inv.payNow': 'Pay Now',
    'portal.inv.redirecting': 'Redirecting…',
    'portal.inv.statusOpen': 'Open',
    'portal.inv.errPay': 'Could not start payment',
    'portal.hist.title': 'Service History',
    'portal.hist.tech': 'Technician:',
    'portal.hist.receipt': 'Receipt',
  },
  es: {
    'common.backHome': 'Volver al inicio',
    'book.badge': 'SOLICITAR SERVICIO',
    'book.title': 'Reserve su servicio contra plagas',
    'book.subtitle': 'Díganos qué necesita y nos comunicaremos para agendar. ¿Prefiere hablar? Llame al',
    'book.successTitle': '¡Solicitud recibida!',
    'book.successMsg': 'Gracias {name} — nuestro equipo se comunicará con usted pronto para confirmar su cita.',
    'book.name': 'Nombre completo *',
    'book.namePh': 'Juana Pérez',
    'book.phone': 'Teléfono celular *',
    'book.phonePh': '(562) 555-1234',
    'book.email': 'Correo electrónico',
    'book.emailPh': 'usted@correo.com',
    'book.date': 'Fecha preferida',
    'book.address': 'Dirección del servicio',
    'book.addressPh': 'Calle 123, Ciudad, CA',
    'book.need': '¿Qué necesita?',
    'book.selectService': 'Seleccione un servicio…',
    'book.notes': 'Notas',
    'book.notesPh': '¿Algo que debamos saber?',
    'book.consentMain': 'Acepto recibir mensajes de texto automatizados y recurrentes sobre el servicio (por ejemplo, recordatorios de citas, avisos de que vamos en camino y recordatorios de pago) de {company} al número proporcionado. El consentimiento no es condición para la compra. La frecuencia de los mensajes puede variar. Pueden aplicar tarifas de mensajes y datos. Responda STOP para cancelar o HELP para ayuda. Consulte nuestros',
    'book.consentAnd': 'y la',
    'book.smsTerms': 'Términos de SMS',
    'book.privacy': 'Política de Privacidad',
    'book.errNamePhone': 'Por favor ingrese su nombre y número de teléfono.',
    'book.errGeneric': 'Algo salió mal. Por favor llámenos.',
    'book.submit': 'Solicitar mi cita',
    'book.sending': 'Enviando…',
    'book.disclaimer': 'Al enviar, usted acepta ser contactado sobre su solicitud de servicio.',
    'svc.General Pest Control': 'Control general de plagas',
    'svc.Termite Inspection / Treatment': 'Inspección / tratamiento de termitas',
    'svc.Rodent Control': 'Control de roedores',
    'svc.Bed Bugs': 'Chinches',
    'svc.Ants / Roaches': 'Hormigas / cucarachas',
    'svc.Bee / Wasp Removal': 'Eliminación de abejas / avispas',
    'svc.Commercial Service': 'Servicio comercial',
    'svc.Other': 'Otro',
    'pay.loading': 'Cargando su factura…',
    'pay.invalidTitle': 'Enlace no disponible',
    'pay.questions': '¿Preguntas? Llame al {phone} o escriba a {email}.',
    'pay.invoice': 'Factura',
    'pay.billTo': 'Facturar a',
    'pay.due': 'Vence',
    'pay.paidTitle': 'Esta factura ya está pagada',
    'pay.paidMsg': '¡Gracias! No hay pago pendiente.',
    'pay.service': 'Servicio',
    'pay.amountDue': 'Monto a pagar',
    'pay.redirecting': 'Redirigiendo al pago seguro…',
    'pay.payNow': 'Pagar {amount} ahora',
    'pay.stripeOff': 'El pago con tarjeta en línea aún no está disponible. Por favor llame al {phone} para pagar.',
    'pay.secure': 'Pago seguro con tecnología de Stripe',
    'pay.errInvalid': 'Este enlace de pago no es válido o ha expirado.',
    'pay.errStart': 'No se pudo iniciar el pago. Por favor intente de nuevo.',
    'login.title': 'Inicie sesión en su cuenta',
    'login.subtitleDemo': 'Elija su rol y use las credenciales de demostración.',
    'login.subtitle': 'Ingrese sus credenciales para continuar.',
    'login.email': 'Correo electrónico',
    'login.password': 'Contraseña',
    'login.forgot': '¿Olvidó?',
    'login.remember': 'Mantener sesión iniciada',
    'login.signInAs': 'Iniciar sesión como {role}',
    'login.signingIn': 'Iniciando sesión…',
    'login.enterBoth': 'Ingrese correo y contraseña',
    'login.invalid': 'Correo o contraseña inválidos',
    'login.failed': 'Error al iniciar sesión. Intente de nuevo.',
    'login.welcome': '¡Bienvenido, {name}!',
    'login.newTo': '¿Nuevo en Xpertpests?',
    'login.bookDemo': 'Reservar una demostración',
    'role.admin': 'Administrador',
    'role.tech': 'Técnico',
    'role.customer': 'Cliente',
    'portal.nav.overview': 'Resumen',
    'portal.nav.book': 'Reservar servicio',
    'portal.nav.messages': 'Mensajes',
    'portal.nav.invoices': 'Facturas',
    'portal.nav.history': 'Historial de servicio',
    'portal.nav.documents': 'Documentos',
    'portal.nav.profile': 'Mi cuenta',
    'portal.upcoming': 'Próximas visitas',
    'portal.reschedule': 'Pedir otra fecha',
    'portal.pay.title': 'Historial de pagos',
    'portal.pay.none': 'Aún no hay pagos registrados.',
    'portal.docs.title': 'Documentos y acuerdos',
    'portal.docs.none': 'Aún no se le han enviado documentos.',
    'portal.docs.sign': 'Revisar y firmar',
    'portal.profile.title': 'Mi cuenta',
    'portal.profile.email': 'Correo para avisos',
    'portal.profile.save': 'Guardar',
    'portal.profile.saved': 'Datos de contacto actualizados.',
    'portal.profile.error': 'No se pudo cargar su cuenta.',
    'portal.profile.addressNote': 'Para cambiar la dirección del servicio, envíenos un mensaje.',
    'portal.title': 'Portal del Cliente',
    'portal.customer': 'Cliente',
    'portal.signOut': 'Cerrar sesión',
    'portal.welcomeBack': 'Bienvenido de nuevo,',
    'portal.nextService': 'Próximo servicio programado:',
    'portal.noUpcoming': 'Aún no hay una visita programada.',
    'portal.book.phone': 'Teléfono de contacto',
    'portal.book.sending': 'Enviando…',
    'portal.book.error': 'No se pudo enviar su solicitud. Llámenos o envíenos un mensaje.',
    'portal.hist.none': 'Aún no hay visitas completadas.',
    'portal.hist.loading': 'Cargando…',
    'portal.accountNo': 'Cuenta n.º',
    'portal.plan': 'Plan',
    'portal.planQuarterly': 'Trimestral',
    'portal.openBalance': 'Saldo pendiente',
    'portal.recentInvoices': 'Facturas recientes',
    'portal.viewAll': 'Ver todas las facturas',
    'portal.quickActions': 'Acciones rápidas',
    'portal.scheduleNew': 'Programar nuevo servicio',
    'portal.scheduleNewSub': 'Reserve una vez o de forma recurrente',
    'portal.updatePay': 'Actualizar método de pago',
    'portal.updatePaySub': 'Tarjeta archivada, pago automático',
    'portal.viewHistory': 'Ver historial de servicio',
    'portal.viewHistorySub': 'Reportes y recibos',
    'portal.yourTech': 'Su técnico',
    'portal.leadTech': 'Técnico asignado',
    'portal.call': 'Llamar',
    'portal.book.title': 'Reservar un servicio',
    'portal.book.subtitle': 'Envíe una solicitud y nuestra oficina le contactará para confirmar el horario.',
    'portal.book.serviceType': 'Tipo de servicio',
    'portal.book.date': 'Fecha preferida',
    'portal.book.time': 'Hora preferida',
    'portal.book.address': 'Dirección del servicio',
    'portal.book.notes': 'Notas para el técnico',
    'portal.book.notesPh': 'Mascota en casa, código de la reja, áreas problemáticas…',
    'portal.book.confirm': 'Enviar solicitud',
    'portal.book.success': 'Solicitud enviada. Nuestra oficina le contactará para confirmar la cita.',
    'portal.svc.quarterly': 'Tratamiento trimestral de plagas',
    'portal.svc.termite': 'Inspección de termitas',
    'portal.svc.bedbug': 'Tratamiento de chinches',
    'portal.svc.mosquito': 'Tratamiento de mosquitos',
    'portal.svc.rodent': 'Servicio de roedores',
    'portal.inv.title': 'Sus facturas',
    'portal.inv.colInvoice': 'Factura',
    'portal.inv.colDate': 'Fecha',
    'portal.inv.colStatus': 'Estado',
    'portal.inv.colAmount': 'Monto',
    'portal.inv.loading': 'Cargando…',
    'portal.inv.none': 'Aún no hay facturas.',
    'portal.inv.view': 'Ver',
    'portal.inv.payNow': 'Pagar ahora',
    'portal.inv.redirecting': 'Redirigiendo…',
    'portal.inv.statusOpen': 'Abierta',
    'portal.inv.errPay': 'No se pudo iniciar el pago',
    'portal.hist.title': 'Historial de servicio',
    'portal.hist.tech': 'Técnico:',
    'portal.hist.receipt': 'Recibo',
  },
};

const LanguageContext = createContext({ lang: 'en', setLang: () => {}, t: (k) => k });
export const useLang = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem('xp_lang') || 'en'; } catch { return 'en'; }
  });
  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem('xp_lang', l); } catch (e) { /* ignore */ }
  }, []);
  const t = useCallback((key, vars) => {
    let s = (STR[lang] && STR[lang][key]) || STR.en[key] || key;
    if (vars) {
      Object.keys(vars).forEach((k) => { s = s.split('{' + k + '}').join(vars[k]); });
    }
    return s;
  }, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
